import { cubicBezier } from './cubic-bezier.mjs';
import { mirrorEasing } from './modifiers/mirror.mjs';
import { reverseEasing } from './modifiers/reverse.mjs';
var backOut = /*@__PURE__*/cubicBezier(0.33, 1.53, 0.69, 0.99);
var backIn = /*@__PURE__*/reverseEasing(backOut);
var backInOut = /*@__PURE__*/mirrorEasing(backIn);
export { backIn, backInOut, backOut };